<template>
  <div :class='classes' class="">
    <button class="border shadow-sm rounded hover:border-gray-600" v-for='(image,i) in images' :key='image.url + "-" + i' @click='select(image)'>
      <img class="object-contain w-24 h-16 md:h-16" :src='image.url' loading="lazy" />
    </button>
  </div>
</template>
<script>
export default {
  props: {
    images: {
      type: Array,
      required: true
    },
    horizontalMode: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    select(image) {
      this.$emit('select', image);
    }
  },
  computed:{
    classes() {
      if (this.horizontalMode) {
        return 'p-2 grid grid-cols-3 md:grid-cols-6 gap-2'
      } else {
        return '';
      }
    }
  }
}
</script>
